import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Box, Button, TextField } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import downloadAsExcel from '../utilities/ExcelExport';

const MasterBookingList = ({ createMasterBookingList }) => {
  const [startDate, setStartDate] = useState(moment().startOf('year'));
  const [endDate, setEndDate] = useState(moment());

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Box display="flex" gap={1}>
          <DatePicker
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(props) => <TextField fullWidth {...props} label={<FormattedMessage id="admindetails.masterBookingStartDate" />} />}
            value={startDate}
            onChange={(date) => setStartDate(date)}
            inputFormat="DD/MM/yyyy"
            maxDate={endDate || undefined}
            mask="__.__.____"
          />
          <DatePicker
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(props) => <TextField fullWidth {...props} label={<FormattedMessage id="admindetails.masterBookingEndDate" />} />}
            value={endDate}
            onChange={(date) => setEndDate(date)}
            inputFormat="DD/MM/yyyy"
            mask="__.__.____"
            minDate={startDate || undefined}
          />
        </Box>
      </LocalizationProvider>
      <Button
        variant="contained"
        sx={{ my: 2 }}
        color="primary"
        onClick={() => {
          const startUTC = moment(startDate).startOf('day');
          const endUTC = moment(endDate).endOf('day');
          createMasterBookingList({ startDate: startUTC.utc(), endDate: endUTC.utc() })
            .then((data) => downloadAsExcel(data, `MASTER-BOOKING-${moment().format('DDMMYY')}`));
        }}
      >
        <FormattedMessage id="admindetails.masterBookingListButton" />
      </Button>
    </div>
  );
};

MasterBookingList.propTypes = {
  createMasterBookingList: PropTypes.func.isRequired,
};

export default MasterBookingList;
